import { ScenarioDetailed } from '@/interfaces'

import { ScenarioResultsTabSectionType } from '../types'
import { ScenarioResultsAggregatesTab } from './ScenarioResultsAggregatesTab'
import { ScenarioResultsSummaryTab } from './ScenarioResultsSummaryTab'
import { ScenarioResultsTimeSeriesTab } from './ScenarioResultsTimeSeriesTab'

interface Props {
  activeSection: ScenarioResultsTabSectionType
  scenarioInfo?: ScenarioDetailed
}
export const ScenarioResultsPageSectionContainer = ({
  activeSection,
  scenarioInfo
}: Props) => {
  if (!scenarioInfo) return null

  switch (activeSection) {
    case ScenarioResultsTabSectionType.SUMMARY:
      return <ScenarioResultsSummaryTab scenarioId={scenarioInfo.id} />
    case ScenarioResultsTabSectionType.AGGREGATES:
      return (
        <ScenarioResultsAggregatesTab
          scenarioId={scenarioInfo.id}
          scenarioConfiguration={scenarioInfo.systemConfiguration}
          projectIsoBa={scenarioInfo.isoBa}
        />
      )
    case ScenarioResultsTabSectionType.TIME_SERIES:
      return (
        <ScenarioResultsTimeSeriesTab
          scenarioId={scenarioInfo.id}
          selectedYears={scenarioInfo.selectedRunYears || []}
        />
      )
  }
}
